<template>
  <v-container class="atom-sitemap" fluid>
    <v-row class="search-bar">
      <v-col md="8" sm="12">
        <v-text-field
          ref="search"
          v-model="search"
          class="form-control"
          :label="$t('Menu.Sitemap.FilterSitemap')"
          append-icon="mdi-magnify"
        />
      </v-col>
    </v-row>

    <div class="card-columns">
      <v-card
        v-for="module in filteredModules"
        :key="module.module"
        elevation="2"
        class="mb-3"
        flat
      >
        <v-card-title>
          <div class="module-title" v-text="module.title" />
          <div :class="getSvgClassName(module.module)" class="module-icon" />
        </v-card-title>
        <v-divider />
        <v-card-text class="module-body">
          <ul>
            <li v-for="(child, index) in module.children" :key="index">
              <router-link :to="child.path" v-text="child.title" />
            </li>
          </ul>
        </v-card-text>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import MenuQuery from "./graphql/MenuQuery.gql";
import _ from "lodash";

export default {
  components: {},
  data() {
    return {
      atomMenu: [],
      search: ""
    };
  },
  apollo: {
    $client: "menu",
    atomMenu: {
      query: MenuQuery,
      variables: {
        path: ""
      },
      update(data) {
        return this.flattenMenu(data.atomMenu);
      },
      fetchPolicy: "cache-first"
    }
  },
  computed: {
    filteredModules() {
      const menu = _.cloneDeep(this.atomMenu);
      if (this.search) {
        menu.forEach(module => {
          module.children = module.children.filter(link => {
            const title = link.title.toLowerCase();
            const search = this.search.toLowerCase();
            return title.includes(search);
          });
        });
      }

      return menu.filter(module => module.children && module.children.length);
    }
  },
  methods: {
    flattenMenu(atomMenu) {
      return _.map(atomMenu, menu => {
        const flatChildren = _.flatMapDeep(menu.children, child => {
          return [child, child.children];
        });

        const filteredFlatChildren = flatChildren
          .filter(link => {
            return link.path != "";
          })
          .sort(this.compareValues("title"));

        return {
          ...menu,
          children: filteredFlatChildren
        };
      });
    },
    getSvgClassName(moduleClass) {
      return "sitemap-module sitemap-module-" + moduleClass;
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.sitemap-module {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent !important;
}
.sitemap-module-HRManager {
  background-image: url(assets/persis_personalmanager_sitemap.svg);
}
.sitemap-module-Training {
  background-image: url(assets/persis_weiterbildung_sitemap.svg);
}
.sitemap-module-ApprenticeManager {
  background-image: url(assets/persis_ausbildungsmanager_sitemap.svg);
}
.sitemap-module-Recruiting {
  background-image: url(assets/persis_bewerbermanagement_sitemap.svg);
}
.sitemap-module-PersonnelFile {
  background-image: url(assets/persis_digitale_personalakte_sitemap.svg);
}
.sitemap-module-HRDevelopment {
  background-image: url(assets/persis_personalentwicklung_sitemap.svg);
}
.sitemap-module-Admin {
  background-image: url(assets/persis_administration_sitemap.svg);
  background-size: 60%;
}
.sitemap-module-Next {
  background-image: url(assets/logo_next.svg);
}

.atom-sitemap {
  margin-bottom: 2rem;
  .card-columns {
    column-count: 3;
    orphans: 1;
    widows: 1;
    .v-card {
      display: inline-block;
      width: 100%;
    }
  }

  .module-header {
    color: #636360;
    .module-image {
      height: 35px;
      width: 35px;
      top: -10px;
      left: -10px;
      position: absolute;
    }

    .module-title {
      font-weight: 600;
    }
  }

  .module-body {
    ul {
      list-style-type: none;
      a {
        text-decoration: none;
      }
    }
  }

  .module-icon {
    width: 3rem;
    height: 3rem;
    position: absolute;
    right: 1rem;
    top: 0.5rem;
  }
}
</style>
